 
const defaultValues = {
  defaultFiltersValues: {}
};

export default (state = defaultValues, action = {}) => {
  const { type, payload } = action;
  
  let stateCopy = JSON.parse(JSON.stringify(state));
  switch (type) {
    case "DEFAULT_FILTER_VALUES":       
      stateCopy.defaultFiltersValues = payload;            
      //console.log("get default payload from redux",stateCopy.defaultFiltersValues);
      return stateCopy;
    default:
      return state;
  }
};
